import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { reduxForm, getFormValues } from 'redux-form';

import { withIntl } from 'ha/i18n';
import { changeLocation } from 'ha/modules/URLLocationHandler';
import { send as sendAlert } from 'ha/modules/Alertbar/actions';
import { getCurrentLanguage } from 'ha/modules/AuthLogic/selectors';
import { submitSearch } from 'ha/modules/SearchListings/actions';
import { getInitialValues } from 'ha/modules/SearchListings/selectors';

import validateForm from './validateForm';
import SearchBar from '../../components/SearchBar';
import withReduxFormHandlers from './withReduxFormHandlers';
const FORM_NAME = 'searchFromHomepage';

const enhance = compose(
  withIntl,
  connect(
    createStructuredSelector({
      initialValues: getInitialValues,
      currentLanguage: getCurrentLanguage,
      formValues: getFormValues(FORM_NAME),
    }),
    {
      onSubmit: submitSearch,
      changeLocation,
      sendAlert,
    },
  ),
  withReduxFormHandlers,
  reduxForm({
    form: FORM_NAME,
    propNamespace: 'form',
    validate: validateForm,
    enableReinitialize: true,
  }),
);

export default enhance(SearchBar);
